<template>
  <!-- ppl totales -->
  <div class="row mb-4">
    <div
      class="card"
      style="
        background-image: url('media/logos/gradient1.jpg');
        background-size: cover;
      "
    >
      <div class="row alinear">
        <div class="col-md-2">
          <img
            src="../../../public/media/logos/bolPng.png"
            alt="Bolivia_image"
          />
        </div>
        <div class="col-md-10">
          <div class="row d-flex align-items-center">
            <div class="col-md-5">
              <div>
                <h1 class="card-title pt-3 mb-5 font-bold">
                  <strong>ESTADO DIGITAL</strong>
                </h1>
              </div>
              <div>
                <h3 class="mb-5 text-white">Régimen Penitenciario</h3>
              </div>
            </div>
            <div class="col-md-6 p-2">
              <h1
                style="font-size: 10em; text-align: right"
                class="card-title pt-3 mb-5 font-bold cantidad alinear"
              >
                <strong>{{ totalPerson }}</strong>
              </h1>
              <h1
                style="text-align: right"
                class="mx-5 mb-5 text-white alinear"
              >
                Personas privadas de libertad
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ppl por departamento -->
  <div class="row">
    <Carousel
      v-if="dataByDepartment.length !== 0"
      :autoplay="3000"
      :breakpoints="breakpoints"
      :wrap-around="true"
    >
      <Slide v-for="value of dataByDepartment" :key="value.departamento">
        <div class="carousel__item">
          <img
            :src="getImgUrl(value.departamento)"
            style="width: 10em; padding: 0; margin: 0"
            alt=""
          />
          {{ value.cantidad }} <br />PPL en: <br />
          {{ value.departamento }}
        </div>
      </Slide>

      <template #addons>
        <Navigation />
        <Pagination />
      </template>
    </Carousel>
  </div>
  <div class="row">
    <!-- ppl por genero -->
    <div class="col-xl-6 col-md-6 col-sm-6">
      <div class="card mb-3 post-card text-left">
        <div class="card-body text-white-secondary bg-gr-blue">
          <h4 class="card-title font-main mb-0 alinear literal_dato">
            Privados de libertad por género
          </h4>
          <div class="row">
            <template v-for="(value, index) in dataByGenre" :key="index">
              <div class="col-md-6 alinear">
                <p class="font-important-stat text-white mb-0 cantidad_dato">
                  {{ value.cantidad }}
                  <i
                    :class="[
                      value.genero == 'MASCULINO'
                        ? 'fas fa-person fa-xs'
                        : 'fas fa-person-dress fa-xs',
                    ]"
                    aria-hidden="true"
                  ></i>
                </p>
                <p class="text-white-secondary mb-0 literal_dato">
                  <span class="font-secondary"></span> {{ value.genero }}
                </p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- ppl por situación jurídica -->
    <div class="col-xl-6 col-md-6 col-sm-6">
      <div class="card mb-3 post-card text-left">
        <div class="card-body text-white-secondary bg-gr-green">
          <h4 class="card-title font-main mb-0 alinear literal_dato">
            Privados de libertad por situación jurídica
          </h4>
          <div class="row">
            <template v-for="(value, index) in dataByStatus" :key="index">
              <div class="col-md-4 alinear">
                <p class="font-important-stat text-white mb-0 cantidad_dato">
                  {{ value.cantidad }}
                </p>
                <p
                  v-if="
                    value.cantidad >= 1 &&
                    value.descripcion_tipo_mandamiento != 'APREMIO'
                  "
                  class="text-white-secondary mb-0 literal_dato"
                >
                  {{ value.descripcion_tipo_mandamiento }}S
                </p>
                <p v-else class="text-white-secondary mb-0 literal_dato">
                  {{ value.descripcion_tipo_mandamiento }}
                </p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ppls por centro penitenciario -->
  <div class="card mt-3">
    <h4 class="card-title fw-bolder text-black text-center mt-10 mb-0">
      Recuento total de privados de libertad en recintos penitenciarios a nivel
      Nacional.
    </h4>
    <div class="card-body pb-5">
      <!--begin::Chart-->
      <apexchart
        width="100%"
        height="400px"
        type="area"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from "vue";
import useFiliation from "@/filiation/composables/useFiliation";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

// eslint-disable-next-line @typescript-eslint/no-var-requires
let es = require("apexcharts/dist/locales/es.json");
export default defineComponent({
  name: "chart-principal",
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  setup() {
    const dataCourtPersonsByCenters = ref([]);
    const dataByGenre = ref([]);
    const dataByStatus = ref([]);
    const dataByDepartment = ref([]);
    const breakpoints = {
      // 350px and up
      // 350: {
      //   itemsToShow: 1.5,
      //   snapAlign: "center",
      // },
      // // 700px and up
      700: {
        itemsToShow: 1.8,
        snapAlign: "center",
      },
      // 1024 and up
      1024: {
        itemsToShow: 2,
        snapAlign: "center",
      },
      // 1700 and up
      1700: {
        itemsToShow: 4.5,
        snapAlign: "center",
      },
    };
    const getImgUrl = (pet) => {
      var images = require.context(
        "../../../public/departamentos/",
        false,
        /\.png$/
      );
      return images("./" + pet + ".png");
    };
    const {
      countPersonsCenters,
      countGenrePersonsCenters,
      countPersonsLegalStatus,
      countCentersByPersons,
      countPersonsByDepartment,
    } = useFiliation();
    let chartOptions = ref({
      chart: {
        id: "vuechart",
        locales: [es],
        defaultLocale: "es",
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: false,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: false,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: [],
          },
          export: {
            csv: {
              filename: "Sirep_report",
              columnDelimiter: ":",
              headerCategory: "category",
              headerValue: "value",
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString();
              },
            },
            svg: {
              filename: "Sirep_report",
            },
            png: {
              filename: "Sirep_report",
            },
          },
          autoSelected: "zoom",
        },
      },
      xaxis: {
        categories: [],
        labels: {
          show: true,
          rotate: -800,
          rotateAlways: true,
          hideOverlappingLabels: false,
          showDuplicates: false,
          trim: true,
          minHeight: 200,
          maxHeight: 200,
          style: {
            colors: [],
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 200,
            cssClass: "apexcharts-xaxis-label",
          },
          offsetX: 0,
          offsetY: 0,
        },
      },
    });
    let series = ref([
      {
        name: "Personas privadas de libertad",
        data: [],
      },
    ]);
    let ser = ref([]);
    let cat = ref([]);
    const updateChart = () => {
      Object.keys(dataCourtPersonsByCenters.value).forEach((key) => {
        ser.value.push(dataCourtPersonsByCenters.value[key].cantidad);
        cat.value.push(
          dataCourtPersonsByCenters.value[key].nombre_recinto_penitenciario
        );
      });
      series.value = [
        {
          data: ser.value,
        },
      ];
      chartOptions.value = {
        ...chartOptions.value,
        ...{
          xaxis: {
            categories: cat.value,
          },
        },
      };
    };
    const countByCenter = async () => {
      const { data } = await countPersonsCenters();
      dataCourtPersonsByCenters.value = data;
      updateChart();
    };
    const countByGenre = async () => {
      const { data } = await countGenrePersonsCenters();
      dataByGenre.value = data;
    };
    const countByStatus = async () => {
      const { data } = await countPersonsLegalStatus();
      dataByStatus.value = data;
    };
    const countByDepartment = async () => {
      const { data } = await countPersonsByDepartment();
      dataByDepartment.value = data;
    };
    const totalPerson = computed(() => {
      const total = dataByGenre.value
        .map((item) => item.cantidad)
        .reduce((prev, curr) => Number(prev) + Number(curr), 0);
      return total;
    });
    onMounted(() => {
      countByCenter();
      countByGenre();
      countByStatus();
      countByDepartment();
    });
    return {
      countCentersByPersons,
      countByCenter,
      countByGenre,
      countByStatus,
      dataByDepartment,
      dataCourtPersonsByCenters,
      dataByGenre,
      dataByStatus,
      series,
      chartOptions,
      updateChart,
      totalPerson,
      getImgUrl,
      breakpoints,
    };
  },
});
</script>
<style>
.hm-gradient {
  background-image: linear-gradient(
    to top,
    #f3e7e9 0%,
    #e3eeff 99%,
    #e3eeff 100%
  );
}
.darken-grey-text {
  color: #2e2e2e;
}
.media {
  display: block;
}
.mobile {
  display: none;
}
.tablet {
  display: none;
}
@media screen and (max-width: 720px) {
  .media {
    display: none;
  }
  .mobile {
    display: block;
  }
  .tablet {
    display: none;
  }
}
@media screen and (max-width: 1200px) {
  .alinear {
    text-align: center !important;
  }
  .cantidad {
    font-size: 6em !important;
  }
  .cantidad_dato {
    font-size: 2em !important;
  }
  .literal_dato {
    font-size: 0.84em !important;
  }
  .media {
    display: none;
  }
  .mobile {
    display: none;
  }
  .tablet {
    display: block;
  }
}
.text-white-secondary {
  color: hsla(0, 0%, 100%, 0.7);
}

.font-main {
  font-size: 18px;
}
.font-important-stat {
  font-size: 40px;
  font-weight: 700;
}
.font-secondary {
  font-size: 16px;
}

.bg-gray {
  background-color: #f5f5fb;
}

.decoration-none {
  text-decoration: none !important;
}

.bg-gr-purple {
  background: #8e2de2; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #4a00e0,
    #8e2de2
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #4a00e0,
    #8e2de2
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.bg-gr-blue {
  background: #0052d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to left,
    #6fb1fc,
    #4364f7,
    #0052d4
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to left,
    #6fb1fc,
    #4364f7,
    #0052d4
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.bg-gr-green {
  background: #00b09b; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to left,
    #96c93d,
    #00b09b
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to left,
    #96c93d,
    #00b09b
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.bg-gr-red {
  background: #ed213a; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #93291e,
    #ed213a
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #93291e,
    #ed213a
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.post-card {
  box-shadow: none;
}
.post-card:hover {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}
.carousel__item {
  min-height: 150px;
  width: 100%;
  background-color: var(--vc-clr-primary);
  color: var(--vc-clr-white);
  font-size: 16px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}
.carousel__slide > .carousel__item {
  transform: scale(1);
  opacity: 0.5;
  transition: 0.5s;
}
.carousel__slide--visible > .carousel__item {
  opacity: 1;
  transform: rotateY(0);
}
.carousel__slide--next > .carousel__item {
  transform: scale(0.9) translate(-10px);
}
.carousel__slide--prev > .carousel__item {
  transform: scale(0.9) translate(10px);
}
.carousel__slide--active > .carousel__item {
  transform: scale(1.1);
}
</style>
